import { useState } from 'react';
import { useAppContext } from './context/AppContext';
import { useNavigate ,Navigate} from 'react-router-dom';

const MainComponent = () => {
  const { authState, user, login,error,setError } = useAppContext();
  const [email, setEmail] = useState(localStorage.getItem('email' || ''));
  const [password, setPassword] = useState('');

  const nav = useNavigate();



  if (authState.loading) {
    return <div>Loading...</div>;
  }

  console.log(user)
  return (
    <div style={{ padding: '20px', maxWidth: '400px', margin: '0 auto' }}>
      {authState.isAuthenticated ? (
     <Navigate to="/dashboard" /> // Redirect if already authenticated
      ) : (
        <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md mt-8">
                    <h2 className="text-2xl font-bold mb-4">Login</h2>
                    {error && <p className="text-red-500 mb-4">{error}</p>}
                    <div className="mb-4">
                      <label className="block text-gray-700">Email</label>
                      <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700">Password</label>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <button
                    onClick={e => login({email,password})}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mb-4"
                  >
                    Log In
                  </button>
                  <p>
                    Do not have an account?{' '}
                    <button
                    className="text-blue-600 hover:underline"
                     onClick={e => nav('/register')}
                    >
                      Register
                    </button>
                  </p>
                  <p>
                    Forgot your password ?{' '}
                    <button
                    className="text-blue-600 hover:underline"
                     onClick={e => nav('/forgot')}
                    >
                      Reset Password
                    </button>
                  </p>
                </div>
           
  )}
  </div>   
  )}


export default MainComponent;



// import { useState } from 'react';
// import { useAppContext } from './context/AppContext';
// import { Navigate, useNavigate } from 'react-router-dom';

// const MainComponent = () => {
//   const { authState, user, login } = useAppContext();
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     try {
//       console.log('Attempting login with:', { email, password });
//       await login({ email, password });
//       setError('');
//       navigate('/dashboard'); // Redirect to dashboard on success
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   if (authState.loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md mt-8">
//            <h2 className="text-2xl font-bold mb-4">Register</h2>
//            {error && <p className="text-red-500 mb-4">{error}</p>}
//            <div className="mb-4">
//              <label className="block text-gray-700">Email</label>
//              <input
//               type="text"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full px-3 py-2 border rounded"
//             />
//           </div>
//           <div className="mb-4">
//             <label className="block text-gray-700">Password</label>
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               className="w-full px-3 py-2 border rounded"
//             />
//           </div>
//           <button
//             onClick={e => login({email,password})}
//             className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 mb-4"
//           >
//             Register
//           </button>
//           <p>
//             Already have an account?{' '}
//             <button
             
//             >
//               Login
//             </button>
//           </p>
//         </div>
//   );
// };

// export default MainComponent;




// // import React, { useState } from 'react'
// // import { useAppContext } from './context/AppContext';

// // const Login = () => {


// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");
// //  const { authState, user, login, logout } = useAppContext();

// //   return (
// //     <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md mt-8">
// //     <h2 className="text-2xl font-bold mb-4">Login</h2>
// //     <div className="mb-4">
// //       <label className="block text-gray-700">Email</label>
// //       <input
// //         type="text"
// //         value={email}
// //         onChange={(e) => setEmail(e.target.value)}
// //         className="w-full px-3 py-2 border rounded"
// //       />
// //     </div>
// //     <div className="mb-4">
// //       <label className="block text-gray-700">Password</label>
// //       <input
// //         type="password"
// //         value={password}
// //         onChange={(e) => setPassword(e.target.value)}
// //         className="w-full px-3 py-2 border rounded"
// //       />
// //     </div>
// //     <button
// //       onClick={e => login({email, password})}
// //       className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mb-4"
// //     >
// //       Login
// //     </button>
// //     <p>
// //       Don't have an account?{' '}
// //       <button
        
// //         className="text-blue-500 hover:underline"
// //       >
// //         Register
// //       </button>
// //     </p>
// //   </div>
// //   )
// // }

// // export default Login